import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { getPoint, resetPoint } from '../../store/actions/point';
import { navigateSpace, updateAppState } from '../../store/actions/app';
import { PointSpace } from '../../containers/xr/space';
import { Helmet } from 'react-helmet';
import { RootState } from '../../types/data';
import { useActions } from '../../hooks';
import LoaderService from '../../services/loader-service';

// type TPointRouteProps = RouteComponentProps<>;
type TPointRouteReduxState = {
  point: RootState['point']['current'];
};

const PointRoute = () => {
  const { university, pointId } = useParams<{ university: string; pointId: string }>();
  const { point } = useSelector<RootState, TPointRouteReduxState>(state => ({ point: state.point.current }));
  const boundActions = useActions({
    getPoint,
    resetPoint,
    navigateSpace,
    updateAppState,
  });

  // data fetching functional
  useEffect(() => {
    if (!pointId) return;

    // create the source
    const reqSource = axios.CancelToken.source();

    (async () => {
      const loaderId = LoaderService.show();

      const {
        __HANDLED_ERROR__,
        payload: {
          data: { response: res },
        },
      } = await ((boundActions.getPoint(university, pointId, reqSource.token) as unknown) as Promise<any>);

      LoaderService.hide(loaderId);

      if (__HANDLED_ERROR__) return;

      boundActions.navigateSpace(res);
    })();

    return () => {
      reqSource.cancel('Point changed.');
      // boundActions.resetPoint();
    };
  }, [boundActions, pointId, university]);

  const pageTitle = point.data?.point_name;

  return (
    <>
      <Helmet>{pageTitle ? <title>{`${pageTitle} | Campus360`} </title> : null}</Helmet>
      <PointSpace />
    </>
  );
};
export default PointRoute;
